// router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/useUserStore";
import { useSettingStore } from "@/stores/useSettingStore";

// Views e Layouts
import LoginView from "@/views/LoginView.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import DashboardView from "@/components/DashboardView.vue";
import OnboardingLayout from "@/layouts/OnboardingLayout.vue";
import FirstAccessView from "@/views/FirstAccessView.vue";

// Componentes
import HomePage from "../components/HomePage.vue";
import LandingPage from "@/components/LandingPage.vue";
import UpgradePage from "../components/User/UpgradePage.vue";
import SchoolSetupWizard from "@/components/User/SchoolSetupWizard.vue";

// ── PATCH: página pública de documentos legais ───────────────────────────
import LegalDocsPage from "@/components/Legal/LegalDocsPage.vue";
// ── FIM PATCH ─────────────────────────────────────────────────────────────

// Componentes de Administração (NOVAS IMPORTAÇÕES)
import UserForm from "@/components/Admin/UserForm.vue";
import GroupForm from "@/components/Admin/GroupForm.vue";
import PermissionForm from "@/components/Admin/PermissionForm.vue";
import UserGroupForm from "@/components/Admin/UserGroupForm.vue";
import PlanForm from "@/components/Admin/PlanForm.vue";
import SubscriptionForm from "@/components/Subscription/SubscriptionForm.vue";
// ✅ NOVO: formulário de atividades gerais
import ActivityGeneralForm from "@/components/ActivityGeneral/ActivityGeneralForm.vue";
import NoteGeneralForm from "@/components/NoteGeneral/NoteGeneralForm.vue";
// ✅ NOVO: formulário de payments
import PaymentForm from "@/components/Payment/PaymentForm.vue";
// ✅ NOVO: formulário de coupons
import CouponForm from "@/components/Coupon/CouponForm.vue";

// ✅ NOVO: vínculos e reservas de cupons
import CouponUserForm from "@/components/CouponUser/CouponUserForm.vue";
import CouponReservationForm from "@/components/CouponReservation/CouponReservationForm.vue";

// Outros componentes do Dashboard
import AuthorForm from "../components/Author/AuthorForm.vue";
import CategoryForm from "@/components/Category/CategoryForm.vue";
import TopicForm from "@/components/Topic/TopicForm.vue";
import NoteTypeForm from "@/components/NoteType/NoteTypeForm.vue";
import TagForm from "@/components/Tag/TagForm.vue";
import TextForm from "@/components/Text/TextForm.vue";
import TextCardsForm from "@/components/Text/TextCardsForm.vue";
import ActivityForm from "@/components/Activity/ActivityForm.vue";
import RightArea from "@/components/RightArea.vue";
// ✅ NOVO: leitor de texto (somente leitura, sem NoteSection)
import TextReader from "@/components/TextReader.vue";
import WithTextModal from "../components/Others/WithTextModal.vue";
import TextSelector from "../components/Others/TextSelector.vue";
import FilingCreateModalForm from "@/components/Others/FilingCreateModalForm.vue";
import QuoteCreateModalForm from "@/components/Others/QuoteCreateModalForm.vue";

import SubscriptionCallback from "@/views/SubscriptionCallback.vue";

import NotePublicView from "@/components/Note/NotePublicView.vue";

import MobileBlocked from "@/components/User/MobileBlocked.vue";

import AiNoteGeneratorForm from "@/components/Note/AiNoteGeneratorForm.vue";

import MemberAccountForm from "@/components/ManagedAccount/MemberAccountForm.vue";

const routes = [
  {
    // Inversão: a raiz passa a abrir a LandingPage (antes abria a HomePage).
    path: "/",
    name: "PublicHome",
    component: LandingPage,
  },
  {
    path: "/home",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/leitura-colaborativa",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/subscription/callback",
    name: "SubscriptionCallback",
    component: SubscriptionCallback,
  },
  {
    path: "/login",
    name: "LoginView",
    component: LoginView,
  },
  {
    path: "/mobile-blocked",
    name: "MobileBlocked",
    component: MobileBlocked,
  },

  // ── PATCH: rotas públicas para documentos legais ─────────────────────────
  {
    path: "/termos-de-uso",
    name: "TermsOfUse",
    component: LegalDocsPage,
    meta: { defaultDoc: "terms" },
  },
  {
    path: "/politica-de-privacidade",
    name: "PrivacyPolicy",
    component: LegalDocsPage,
    meta: { defaultDoc: "privacy" },
  },
  // ── FIM PATCH ─────────────────────────────────────────────────────────────

  {
    path: "/welcome",
    name: "Onboarding",
    component: OnboardingLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "UpgradePage",
        component: UpgradePage,
      },
      {
        path: "escola",
        name: "SchoolSetupWizard",
        component: SchoolSetupWizard,
      },
    ],
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "home",
        name: "DashboardHome",
        component: DashboardView,
      },
      {
        path: "start",
        name: "FirstAccessView",
        component: FirstAccessView,
      },
      { path: "users", name: "users", component: UserForm },
      { path: "groups", name: "groups", component: GroupForm },
      { path: "permissions", name: "permissions", component: PermissionForm },
      { path: "user-group", name: "user-group", component: UserGroupForm },
      {
        path: "member-accounts",
        name: "MemberAccountForm",
        component: MemberAccountForm,
      },

      { path: "plans", name: "PlanForm", component: PlanForm },
      {
        path: "subscriptions",
        name: "SubscriptionForm",
        component: SubscriptionForm,
      },
      // ✅ NOVO: rota de payments (abaixo de subscriptions)
      {
        path: "payments",
        name: "PaymentForm",
        component: PaymentForm,
      },
      // ✅ NOVO: rota de coupons (abaixo de payments)
      {
        path: "coupons",
        name: "CouponForm",
        component: CouponForm,
      },
      // ✅ NOVO: rota de vínculos usuário-cupom
      {
        path: "coupon-users",
        name: "CouponUserForm",
        component: CouponUserForm,
      },

      // ✅ NOVO: rota de reservas de cupom
      {
        path: "coupon-reservations",
        name: "CouponReservationForm",
        component: CouponReservationForm,
      },
      { path: "authors", name: "AuthorForm", component: AuthorForm },
      { path: "categories", name: "CategoryForm", component: CategoryForm },
      { path: "topics", name: "TopicForm", component: TopicForm },
      { path: "note-types", name: "NoteTypeForm", component: NoteTypeForm },
      { path: "note-subtypes", name: "TagForm", component: TagForm },
      { path: "texts", name: "TextForm", component: TextForm },
      {
        path: "texts-cards",
        name: "TextCardsForm",
        component: TextCardsForm,
      },
      // ✅ NOVO: rota de atividades gerais (abaixo de texts)
      {
        path: "activities-general",
        name: "ActivityGeneralForm",
        component: ActivityGeneralForm,
      },
      {
        path: "notes-general",
        name: "NoteGeneralForm",
        component: NoteGeneralForm,
      },
      {
        path: "ai-note-generator",
        name: "AiNoteGeneratorForm",
        component: AiNoteGeneratorForm,
      },
      {
        path: "activities/:textId/:textTitle",
        name: "ActivityForm",
        component: ActivityForm,
        props: true,
      },
      { path: "right-area", name: "RightArea", component: RightArea },
      // ✅ NOVO: leitor de texto (espelha o padrão de RightArea)
      { path: "text-reader", name: "TextReader", component: TextReader },
      { path: "text-selector", name: "TextSelector", component: TextSelector },
      {
        path: "with-text-modal/:linkId",
        name: "WithTextModal",
        component: WithTextModal,
        props: true,
      },
      {
        path: "quote-create",
        name: "QuoteCreateModalForm",
        component: QuoteCreateModalForm,
      },
      {
        path: "filing-create",
        name: "FilingCreateModalForm",
        component: FilingCreateModalForm,
      },
      // Entrar em /dashboard sem filho cai na estante, o mesmo destino do login.
      { path: "", redirect: { name: "TextCardsForm" } },
    ],
  },
  {
    // Rota pública — sem requiresAuth.
    // Usuários autenticados são redirecionados pelo próprio componente
    // para o DashboardHome ao montar (ver NotePublicView.vue onMounted).
    path: "/shared/notes/:shareToken",
    name: "NotePublicView",
    component: NotePublicView,
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// --- GUARDA GLOBAL DE ROTA ---
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();
  const settingStore = useSettingStore();

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

  const publicMobileAllowedNames = [
    "PublicHome",
    "HomePage",
    "LandingPage",
    "LoginView",
    "MobileBlocked",
    //"SubscriptionCallback",
    "NotePublicView",
    // ── PATCH: documentos legais acessíveis em mobile ──────────────────────
    "TermsOfUse",
    "PrivacyPolicy",
    // ── FIM PATCH ───────────────────────────────────────────────────────────
  ];

  // 1) Tenta auto-login se ainda não tem usuário
  if (!userStore.currentUser) {
    await userStore.tryAutoLogin();
  }

  const isAuthenticated = userStore.isAuthenticated;

  // Bypass de mobile para a conta de sistema: "Sys" acessa o app inteiro pelo
  // celular, sem cair na tela de indisponibilidade.
  const isSysUser = userStore.currentUser?.userName === "Sys";
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // 2) Se está autenticado e ainda não carregou settings, carrega aqui
  if (isAuthenticated && !settingStore.isLoaded) {
    try {
      await settingStore.fetchSetting();
      console.log("✅ Settings carregadas no router.beforeEach");
    } catch (err) {
      console.warn("⚠️ Erro ao carregar settings no router:", err.message);
    }
  }

  // Inicia polling de assinatura se autenticado e polling ainda não está rodando
  if (isAuthenticated) {
    const { useSubscriptionStatusStore } = await import(
      "@/stores/useSubscriptionStatusStore"
    );
    const subscriptionStatusStore = useSubscriptionStatusStore();
    if (!subscriptionStatusStore._intervalId) {
      subscriptionStatusStore.startPolling();
    }
  }

  // 3) Bloqueio mobile:
  //    no celular, só pode acessar homepage e rotas públicas explicitamente permitidas
  if (isMobile && !isSysUser && !publicMobileAllowedNames.includes(to.name)) {
    return next({ name: "MobileBlocked" });
  }

  // 3.1) Tela de primeiro acesso só faz sentido para quem ainda não concluiu o
  //      onboarding. Sem esta guarda, qualquer usuário poderia abrir
  //      /dashboard/start pela URL e redisparar litterae_first_access_view.
  if (
    isAuthenticated &&
    to.name === "FirstAccessView" &&
    userStore.currentUser?.onboardingComplete === true
  ) {
    return next({ name: "DashboardHome" });
  }

  // 4) Regras de navegação
  if (requiresAuth && !isAuthenticated) {
    next({ name: "LoginView" });
  } else if (isAuthenticated && to.name === "LoginView" && (!isMobile || isSysUser)) {
    const user = userStore.currentUser;
    // Mesmo destino do LoginForm: quem ja esta autenticado e cai na tela de
    // login vai para a estante.
    next(user?.onboardingComplete ? { name: "TextCardsForm" } : { name: "FirstAccessView" });
  } else {
    next();
  }
});

export default router;
